/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import useMasterApi from '../../../services/useMasterApi';
import { Box } from '@mui/material';
import CustomDataTable from '../../../components/CustomDataTable/CustomDataTable';
import { ENDPOINT } from '../../../services/endPoints';
import CommentDialog from './CommentDialog';
import useToast from '../../../hooks/useToast';
import CustomToast from '../../../components/Toast/CustomToast';

const DoctorCommentsForm = (props) => {
    const {formData} = props;
    const hospitalId = formData?.hospital_id;
    const form_code = formData?.form_code;
    const hospital_name = formData?.hospital_Name;
    const { toastMessage, toast, toastType, setToast, showToast } = useToast()

  const {post, data: commentData } = useMasterApi()
  const excludedKeys = ["hospital_comments_id", "form_code",'hospital_id', 'updatedAt',  'deletedAt',];

 

  const onSubmit = (comment) => {
    post(`${ENDPOINT.DOCTOR_COMMENTS}`, { hospital_comments: comment, form_code: form_code, hospital_id: hospitalId, hospital_name: hospital_name })
  }

  useEffect(()=>{
    if(commentData.success){
      showToast("success", "Comment Added Successfully")
    }
  },[commentData])


  const compareValue = [
    "hospital_comments_id",
    "hospital_id",
    "hospital_name",
    "form_code",
    "hospital_comments",
    "createdAt"
  ];
  
  const customKeyName = {
    hospital_name: "Tertiary Healthcare",
    hospital_comments: "Comment",
    createdAt: "Comment Date"
  };

  const customWidth = {
    hospital_name: "200px",
    hospital_comments: "800px",
    createdAt: "150px",
  };


  return (
    <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem", my: 1 }}>
        {/* <Box>
         <CommentDialog onSubmit={onSubmit}/>
        </Box> */}
       {formData !== undefined  ?  <CustomDataTable
                tableTitle={"Comments List"}
                endPoint={`${ENDPOINT.DOCTOR_COMMENTS}/${form_code}`}
                filterKey={"hospital_name"}
                excludedKeys={excludedKeys}
                isCommentAdded={commentData}
                compareValue={compareValue}
                customKeyName={customKeyName}
                doc_form_code={form_code}
                customWidth={customWidth}

          /> : null}
        </Box>
        {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </>
  )
}

export default DoctorCommentsForm